// ========================================
// SCROLL FREEZE FIX - Ensures scroll works on page load
// ========================================
(function() {
    function unlockScroll() {
        let issuesFound = false;
        let debugInfo = [];
        
        // Check and remove scroll-locking classes from html
        const htmlClasses = document.documentElement.classList;
        if (htmlClasses.contains('lock') || htmlClasses.contains('no-scroll')) {
            debugInfo.push('⚠️ Found lock classes on HTML element: ' + 
                           (htmlClasses.contains('lock') ? 'lock ' : '') + 
                           (htmlClasses.contains('no-scroll') ? 'no-scroll' : ''));
            htmlClasses.remove('lock', 'no-scroll');
            issuesFound = true;
        }
        
        // Check and remove drawer_open from body
        if (document.body.classList.contains('drawer_open')) {
            debugInfo.push('⚠️ Found drawer_open class on body');
            document.body.classList.remove('drawer_open');
            issuesFound = true;
        }
        
        // Check and reset the lock layer counter
        if (typeof window.lockLayerCount !== 'undefined' && window.lockLayerCount > 0) {
            debugInfo.push('⚠️ lockLayerCount was: ' + window.lockLayerCount);
            window.lockLayerCount = 0;
            issuesFound = true;
        }
        
        // Check and remove any inline overflow styles
        if (document.documentElement.style.overflow) {
            debugInfo.push('⚠️ Found inline overflow style on HTML: ' + document.documentElement.style.overflow);
            document.documentElement.style.removeProperty('overflow');
            issuesFound = true;
        }
        
        if (document.body.style.overflow) {
            debugInfo.push('⚠️ Found inline overflow style on body: ' + document.body.style.overflow);
            document.body.style.removeProperty('overflow');
            issuesFound = true;
        }
        
        // Check PageOverlay visibility
        const pageOverlay = document.querySelector('.PageOverlay');
        if (pageOverlay && pageOverlay.classList.contains('is-visible')) {
            debugInfo.push('⚠️ PageOverlay was visible');
            pageOverlay.classList.remove('is-visible');
            issuesFound = true;
        }
        
        // Log the results
        if (issuesFound) {
            console.group('%c🔓 Scroll Lock Fix Applied', 'color: #ff6b6b; font-weight: bold;');
            debugInfo.forEach(info => console.log(info));
            console.log('✅ All scroll locks have been removed');
            console.groupEnd();
        } else {
            console.log('%c✅ No scroll lock issues detected', 'color: #51cf66; font-weight: bold;');
        }
        
        // Final verification
        const finalCheck = {
            htmlLock: document.documentElement.classList.contains('lock'),
            htmlNoScroll: document.documentElement.classList.contains('no-scroll'),
            bodyDrawer: document.body.classList.contains('drawer_open'),
            lockCounter: window.lockLayerCount || 0,
            htmlOverflow: document.documentElement.style.overflow || 'none',
            bodyOverflow: document.body.style.overflow || 'none'
        };
        
        console.log('%c📊 Scroll Lock Status:', 'color: #339af0; font-weight: bold;', finalCheck);
    }
    
    // Run immediately if DOM is ready, or wait for it
    console.log('%c🔍 Scroll Lock Monitor Initialized', 'color: #845ef7; font-weight: bold;');
    
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
            console.log('%c🔍 Running scroll check on DOMContentLoaded', 'color: #845ef7;');
            unlockScroll();
        });
    } else {
        console.log('%c🔍 Running immediate scroll check', 'color: #845ef7;');
        unlockScroll();
    }
    
    // Also run after a short delay as a failsafe
    setTimeout(function() {
        console.log('%c🔍 Running delayed scroll check (100ms)', 'color: #845ef7;');
        unlockScroll();
    }, 100);
    
    // Listen for page visibility changes (browser back/forward)
    document.addEventListener('visibilitychange', function() {
        if (!document.hidden) {
            console.log('%c🔍 Page became visible, checking scroll lock', 'color: #845ef7;');
            setTimeout(unlockScroll, 50);
        }
    });
    
    // Add debug monitoring for lock class changes
    if (window.MutationObserver) {
        const observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                    const target = mutation.target;
                    if (target === document.documentElement || target === document.body) {
                        const classes = target.classList;
                        if (classes.contains('lock') || classes.contains('no-scroll') || classes.contains('drawer_open')) {
                            console.log('%c🔒 Lock class added:', 'color: #ffa94d; font-weight: bold;', {
                                element: target === document.documentElement ? 'html' : 'body',
                                classes: Array.from(classes).join(' '),
                                timestamp: new Date().toLocaleTimeString()
                            });
                        }
                    }
                }
            });
        });
        
        // Observe class changes on html and body
        observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
        observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
        
        console.log('%c👁️ Mutation Observer active for scroll lock monitoring', 'color: #845ef7;');
    }
})();

// ========================================
// PDP - Model Size Info on Media Gallery 4
// ========================================
window.toggleModelInfo = function (element) {
    let modelSizeText = element.querySelector(".model-size-info");
    let modelInfo = element.querySelector(".product-model-info");

    if (modelInfo.style.display === "none" || modelInfo.style.display === "") {
        modelInfo.style.display = "block";
        modelSizeText.style.display = "none";
    } else {
        modelInfo.style.display = "none";
        modelSizeText.style.display = "block";
    }
};

document.addEventListener("DOMContentLoaded", function () {
    let modelContainers = document.querySelectorAll(".model-product-info");

    modelContainers.forEach(function (modelContainer) {
        let modelSizeText = modelContainer.querySelector(".model-size-info");
        let modelInfo = modelContainer.querySelector(".product-model-info");

        const isMobile = window.innerWidth <= 768;

        if (isMobile) {
            // On Mobile: Show for 3 seconds, then hide
            modelInfo.style.display = "block";
            modelSizeText.style.display = "none";

            setTimeout(function () {
                modelInfo.style.display = "none";
                modelSizeText.style.display = "block";
            }, 3000);
        } else {
            // On Desktop: Show by default (but allow toggle too)
            modelInfo.style.display = "block";
            modelSizeText.style.display = "none";
        }
    });
});

// ========================================
// PDP - Model Size Info on Media Gallery 3
// ========================================
// window.toggleModelInfo = function (element) {
//     let modelSizeText = element.querySelector('.model-size-info');
//     let modelInfo = element.querySelector('.product-model-info');

//     if (modelInfo.style.display === "none" || modelInfo.style.display === "") {
//       modelInfo.style.display = "block";
//       modelSizeText.style.display = "none";
//     } else {
//       modelInfo.style.display = "none";
//       modelSizeText.style.display = "block";
//     }
//   };

//   document.addEventListener("DOMContentLoaded", function () {
//     let modelContainers = document.querySelectorAll('.model-product-info');

//     modelContainers.forEach(function (modelContainer) {
//       let modelSizeText = modelContainer.querySelector('.model-size-info');
//       let modelInfo = modelContainer.querySelector('.product-model-info');

//       // Check screen width to determine mobile vs desktop
//       const isMobile = window.innerWidth <= 768;

//       if (isMobile) {
//         // On mobile: Show info for 3 seconds, then hide
//         modelInfo.style.display = "block";
//         modelSizeText.style.display = "none";

//         setTimeout(function () {
//           modelInfo.style.display = "none";
//           modelSizeText.style.display = "block";
//         }, 3000);
//       } else {
//         // On desktop: Hide by default
//         modelInfo.style.display = "none";
//         modelSizeText.style.display = "block";
//       }
//     });
//   });

// ========================================
// PDP - Model Size Info on Media Gallery 2
// ========================================
// window.toggleModelInfo = function (element) {
//     let modelSizeText = element.querySelector('.model-size-info');
//     let modelInfo = element.querySelector('.product-model-info');

//     if (modelInfo.style.display === "none" || modelInfo.style.display === "") {
//         modelInfo.style.display = "block";
//         modelSizeText.style.display = "none";
//     } else {
//         modelInfo.style.display = "none";
//         modelSizeText.style.display = "block";
//     }
// };

// Auto-show the model info for 3 seconds on page load, then hide it
// document.addEventListener("DOMContentLoaded", function () {
//     let modelContainers = document.querySelectorAll('.model-product-info');

//     modelContainers.forEach(function (modelContainer) {
//         let modelSizeText = modelContainer.querySelector('.model-size-info');
//         let modelInfo = modelContainer.querySelector('.product-model-info');

//         modelInfo.style.display = "block"; // Show Model Info
//         modelSizeText.style.display = "none"; // Hide 'Model Size' label initially

//         setTimeout(function () {
//             modelInfo.style.display = "none"; // Hide Model Info after 3 seconds
//             modelSizeText.style.display = "block"; // Show 'Model Size' label
//         }, 3000);
//     });
// });

// ========================================
// PDP - Model Size Info on Media Gallery 1
// ========================================
// window.toggleModelInfo = function (element) {
//     let modelSizeText = element.querySelector('.model-size-info');
//     let modelInfo = element.querySelector('.product-model-info');

//     if (modelInfo.style.display === "none" || modelInfo.style.display === "") {
//         modelInfo.style.display = "block";
//         modelSizeText.style.display = "none";
//     } else {
//         modelInfo.style.display = "none";
//         modelSizeText.style.display = "block";
//     }
// };

// window.toggleModelInfo = function toggleModelInfo(element) {
//     const infoParagraph = element.querySelector('.product-model-info');
//     if (infoParagraph) {
//         infoParagraph.classList.toggle('hidden');
//     }
// };

// ========================================
// ========================================
$(document).ready(function () {
    // Add your custom JavaScript code here
    console.log("Custom JavaScript is working!");

    // Upsell Popup on PDP
    $(".show_me_btn").click(function () {
        $(".upsell_popup").addClass("active");
        // alert("This is a test");
    });

    $(".popup_overlay").click(function () {
        $(".upsell_popup").removeClass("active");
    });

    // On Variant selection
    $(".up_variant select").on("change", function () {
        $("option:selected", this)
            .attr("selected", !0)
            .siblings()
            .removeAttr("selected");
        var t = $(this).attr("data-id"),
            e = $("option:selected", this).attr("data-price"),
            o = $("option:selected", this).attr("data-cprice"),
            c = $("option:selected", this).val();
        $(
            '.up_main_product_inner[data-productid="' +
                t +
                '"] .selected_product'
        ).val(c),
            $(
                '.up_main_product_inner[data-productid="' + t + '"] .main_price'
            ).text(e),
            $(
                '.up_main_product_inner[data-productid="' +
                    t +
                    '"] .compare_price'
            ).text(o);
    });

    $(".up_variant .selected_product").each(function () {
        $(this).change(function () {
            var t = $("input.selected_product:checkbox:checked").length;
            t >= 1
                ? $(".add_up_btn").removeClass("disabled")
                : $(".add_up_btn").addClass("disabled");
        });
    });

    // Add items to the Cart using the Shopify Queue
    $(".add_up_btn").click(function (t) {
        t.preventDefault();
        Shopify.queue = [];

        $(".up_variant .selected_product:checked").each(function () {
            var e = $(this).val();
            console.log(e);
            Shopify.queue.push({
                variantId: e,
                quantity: 1,
            });
        });

        Shopify.moveAlong = function () {
            if (Shopify.queue.length) {
                var e = Shopify.queue.shift(),
                    o = "id=" + e.variantId + "&quantity=" + e.quantity;
                $.ajax({
                    type: "POST",
                    url: "/cart/add.js",
                    dataType: "json",
                    data: o,
                    success: function (c) {
                        Shopify.moveAlong();
                    },
                    error: function () {
                        Shopify.queue.length && Shopify.moveAlong();
                    },
                });
            } else {
                document.documentElement.dispatchEvent(
                    new CustomEvent("cart:refresh", { bubbles: !0 })
                );
                $(".add_up_btn").text("Added to cart");
                $(".upsell_popup").removeClass("active");
                $("body").addClass("drawer_open");
                $(".studio-cart-count").text(
                    +$(".studio-cart-count").text() + 2
                );
                $("#sidebar-cart").attr("aria-hidden", "false");
                $("html").addClass("no-scroll lock");
                $(".PageOverlay").addClass("is-visible");
                // $('a.Header__Icon[data-drawer-id="sidebar-cart"]').trigger("click");
                $("a.header-cart-icon span.sr-only").trigger("click");
            }
        };
        Shopify.moveAlong();
    });

    // Klaviyo code from Old theme custom.js
    // $(document).on("click", ".ProductForm__Variants li.available", function () {
    //     setTimeout(function () {
    //         $("button.ProductForm__AddToCart, .ProductForm__QuantitySelector").show(), $(".custom_notify_me").removeClass("active"), $(".custom_notify_button").removeClass("active");
    //     }, 200),
    //         $("a.klaviyo-bis-trigger.Button").addClass("hide").hide();
    // });
});

$(document).ready(function () {
    $(".cstm-accordian > a").on("click", function () {
        $(this).hasClass("active")
            ? ($(this).removeClass("active"),
              $(this).siblings(".content").slideUp(200),
              $(".cstm-accordian > a svg")
                  .removeClass("fa-minus")
                  .addClass("fa-plus"))
            : ($(".cstm-accordian > a svg")
                  .removeClass("fa-minus")
                  .addClass("fa-plus"),
              $(this).find("svg").removeClass("fa-plus").addClass("fa-minus"),
              $(".cstm-accordian > a").removeClass("active"),
              $(this).addClass("active"),
              $(".content").slideUp(200),
              $(this).siblings(".content").slideDown(200));
    });

    $(".accordion-item").first().find(".accordion-title").addClass("active");
    $(document).on("click", ".accordion-title", function () {
        if ($(this).hasClass("active")) {
            $(this).removeClass("active");
        } else {
            $(".accordion-title").removeClass("active");
            $(this).addClass("active");
        }
        if ($(".accordion-content").is(":visible")) {
            $(".accordion-content").slideUp(500);
        }
        if ($(this).next(".accordion-content").is(":visible")) {
            $(this).next(".accordion-content").slideUp(500);
        } else {
            $(this).next(".accordion-content").slideDown(500);
        }
    });
}); // END $(document).ready(function () {

//  $(document).ready(function() {

//     console.log('Boost Filter JavaScript is working!');

//     const sortByLabel = $(".boost-sd__sorting-label"); // Replace .sort-by-class with the correct class or ID of your SORT BY label
//     if (sortByLabel.length) {
//         sortByLabel.text(sortByLabel.text().replace(":", ""));
//     }
// });

// $(document).ready(function() {
//     console.log('Boost Filter JavaScript is working!');
//     setTimeout(function() {
//         var $sortByLabel = $("span.boost-sd__sorting-label"); // Update selector based on inspection
//         if ($sortByLabel.length) {
//             // $sortByLabel.text($sortByLabel.text().replace(": ", ":::"));
//             $sortByLabel.text($sortByLabel.text().replace("Sort by: ", "Sort By "));
//         }
//     }, 1000); // Adjust the timing as needed
// });

// $(document).ready(function() {
//     console.log('Boost Filter JavaScript is working!');
//     $(".boost-sd__sorting-label").html("Sort By");
//     alert("Collection page...");
// });

// ========================================
// PDP - Hide Wishlist Button for Sold Out Variants - Added by Arslan
// ========================================
$(document).ready(function () {
    console.log("Wishlist visibility handler initialized");

    // Function to check variant availability and hide/show wishlist button
    function toggleWishlistVisibility() {
        // Get the current selected variant from the variant picker
        const variantPicker = document.querySelector("variant-picker");
        if (!variantPicker) return;

        const variantScript = variantPicker.querySelector(
            "script[data-variant]"
        );
        if (!variantScript) return;

        let currentVariant;
        try {
            currentVariant = JSON.parse(variantScript.textContent);
        } catch (e) {
            console.log("Could not parse variant data");
            return;
        }

        // Find the wishlist button - Updated selector to be more specific
        const wishlistButtons = document.querySelectorAll(
            '.iWishAdd, a[class*="iwish"], a[href*="wishlist"], .iwish-app-block-product a, button:has(.iWishAdd)'
        );
        
        console.log("Found wishlist buttons:", wishlistButtons.length);

        wishlistButtons.forEach(function(wishlistButton) {
            if (currentVariant && currentVariant.available === false) {
                // Hide wishlist button for sold out variants - Using important to override any CSS
                wishlistButton.style.setProperty("display", "none", "important");
                // Also try hiding parent container if it exists
                if (wishlistButton.closest('.iwish-app-block-product')) {
                    wishlistButton.closest('.iwish-app-block-product').style.setProperty("display", "none", "important");
                }
                console.log("Wishlist button hidden - variant sold out", wishlistButton);
            } else {
                // Show wishlist button for available variants
                wishlistButton.style.removeProperty("display");
                // Also show parent container if it exists
                if (wishlistButton.closest('.iwish-app-block-product')) {
                    wishlistButton.closest('.iwish-app-block-product').style.removeProperty("display");
                }
                console.log("Wishlist button shown - variant available", wishlistButton);
            }
        });
    }

    // Initial check on page load
    toggleWishlistVisibility();

    // Listen for variant changes
    document.addEventListener("variant:change", function (event) {
        console.log("Variant changed, updating wishlist visibility");
        // Small delay to ensure variant data is updated
        setTimeout(toggleWishlistVisibility, 100);
    });

    // Also listen for product:rerender events (backup)
    document.addEventListener("product:rerender", function (event) {
        console.log("Product rerendered, updating wishlist visibility");
        setTimeout(toggleWishlistVisibility, 100);
    });

    // Monitor for dynamically added wishlist buttons (app-specific)
    const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            if (mutation.type === "childList") {
                mutation.addedNodes.forEach(function (node) {
                    if (
                        node.nodeType === 1 &&
                        (node.classList && (
                            node.classList.contains("iWishAdd") ||
                            node.classList.contains("iwish-app-block-product")
                        ) ||
                        (node.querySelector &&
                            (node.querySelector(".iWishAdd") ||
                             node.querySelector(".iwish-app-block-product"))))
                    ) {
                        console.log(
                            "New wishlist button detected, checking visibility"
                        );
                        setTimeout(toggleWishlistVisibility, 100);
                    }
                });
            }
        });
    });

    // Start observing for dynamically added content
    observer.observe(document.body, {
        childList: true,
        subtree: true,
    });
});
